import './scss/index.scss';
import { dcFactory } from 'dc';
import AccordionComponent from './js/accordion.js';

dcFactory.register(AccordionComponent);

export {
    AccordionComponent,
};
